import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { resetFilter } from '../store/slice'
import classes from './index.module.scss'

export const ResetBtn = () => {
  const dispatch = useDispatch()

  const onClick = () => {
    dispatch(resetFilter())
  }

  return (
    <Element
      onClick={onClick}
      className={classes.resetBtn}
      style={{ backgroundColor: '#0553A5', color: '#FFFFFF' }}
    >
      <Icon className="icon-reset" style={{ fontSize: 10 }} />
      <Translate value="common.RESET" />
    </Element>
  )
}
